export default "__VITE_ASSET__44c6a49e__"